import styled, { css } from 'styled-components';

export const Container = styled.div`
  background: #0f0f0f;

  display: flex;
  overflow: hidden;

  flex: 1;
  width: 100%;
  height: 100%;
`;

export const Wrapper = styled.div`
  width: 100%;
  overflow: auto;

  ::-webkit-scrollbar {
    display: none;
  }
`;

export const PageHeader = styled.div`
  width: 100%;
  height: 12rem;

  background: #242424;

  padding: 0 5.6rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;

  @media (max-width: 1024px) {
    padding: 0 3rem;
  }
`;

export const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  .header-container {
    display: flex;
    justify-content: space-between;
  }

  .info-container {
    display: flex;
    margin-top: 1.4rem;

    @media (max-width: 425px) {
      align-items: center;
      justify-content: center;
      margin-top: 0;
    }

    div {
      color: white;
      font-size: 1.8rem;
      display: flex;

      margin-right: 3rem;

      strong {
        margin-right: 0.4rem;
      }
    }

    button {
      background: transparent;
      border: none;

      font-size: 0;

      transition: 0.2s;

      :hover {
        filter: brightness(0.9);
      }
    }
  }
`;

export const PageHeaderBackButton = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 25px;
  align-items: center;
  justify-content: center;
  color: #ffdf22;
  cursor: pointer;
`;

export const PageHeaderBackButtonLabel = styled.div`
  font-weight: bold;
  padding-left: 5px;
  text-transform: uppercase;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const HeaderButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 0px;

  display: flex;
  flex-direction: column;
  justify-content: space-around;

  margin: 0.8rem 0;

  > a,
  button {
    display: flex;
    align-items: center;
    justify-content: center;

    color: #fff;

    padding: 0.4rem;

    border-radius: 0.2rem;

    transition: ${({ theme }) => theme.transition.default};

    :hover {
      transform: scale(1.05);
    }

    :active {
      transform: scale(0.99);
    }
    background: transparent linear-gradient(155deg, #ffdf22 0%, #ffd503 100%);

    :last-child {
      background: transparent linear-gradient(155deg, #b50808 0%, #d90606 100%);
    }
  }

  @media (min-width: 425px) {
    > a,
    button {
      border-radius: 50%;
    }
  }

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: baseline;

    margin: 0;

    > a,
    button {
      min-width: 3.3rem;
      min-height: 3.3rem;
    }

    > button {
      margin-top: 0rem;
      margin-left: 1.6rem;
    }
  }
`;

export const Sidebar = styled.div`
  width: 10rem;
  height: 100%;

  border-right: 1px solid #cfcfcf;

  > ul {
    > li {
      display: flex;
      align-items: center;

      height: 5.2rem;
      padding-left: 1rem;

      cursor: pointer;
      transition: ${({ theme }) => theme.transition.default};

      > p {
        font-size: 1.6rem;
        line-height: 3.5rem;
        color: #ffffff;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      :hover {
        background: #242424;
      }

      &.active {
        background: #242424;
        border-right: 4px solid #ffd503;

        > p {
          font-weight: bold;
          color: #ffdf22;
        }
      }

      @media (min-width: 768px) {
        padding-left: 3.2rem;

        > p {
          font-size: 1.9rem;
        }
      }
    }
  }

  @media (min-width: 768px) {
    width: 27rem;
  }
`;
export const Section = styled.section`
  margin: 3.6rem 6.2rem;

  @media (max-width: 1024px) {
    margin: 2rem;
    max-width: 100%;
  }
`;

export const Grid = styled.div`
  width: 60rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 4rem 2rem;
  padding-bottom: 4rem;

  @media (max-width: 1280px) {
    grid-template-columns: 1fr;
  }
`;

export const SectionRow = styled.div`
  display: flex;

  width: 47rem;
  padding-bottom: 4rem;

  @media (max-width: 425px) {
    width: 100%;
  }
`;

export const GridRow = styled.div`
  display: flex;

  flex-direction: column;
`;

export const SectionSet = styled.span`
  display: flex;
  flex-direction: column;
  width: 100%;
  word-break: break-word;
`;

export const Label = styled.label`
  color: #fff;
  font-size: 1.8rem;
  font-weight: bold;
`;

export const Content = styled.span`
  color: #fff;
  font-size: 1.8rem;
`;

type SectionLabelProps = {
  secondary?: boolean;
};

export const SectionLabel = styled.h1<SectionLabelProps>`
  margin-bottom: 3.1rem;

  font-size: 1.8rem;
  text-transform: uppercase;
  color: #ffdf22;

  ${(props) =>
    props.secondary &&
    css`
      margin-top: 5.8rem;
    `}

  @media (max-width: 1250px) {
    display: flex;
  }
`;

export const ModalContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 4rem;
  display: flex;

  flex-direction: column;
  align-items: center;

  h1 {
    margin-bottom: 4rem;
  }

  section {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2rem;

    width: 100%;
    height: 100%;

    div {
      display: inline-block;
      text-align: center;
    }
  }
`;

export const DeleteModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    margin-bottom: 3rem;
    text-transform: uppercase;
  }

  p {
    width: 80%;
    font-size: 1.8rem;
    text-align: center;
    margin-bottom: 6rem;
  }

  div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    button {
      width: 10rem;
      height: 4rem;
      background: transparent linear-gradient(96deg, #000000 0%, #232323 100%)
        0% 0% no-repeat padding-box;
      border-radius: 50px;
      opacity: 1;

      color: #fff;
      font-weight: bold;

      transition: 0.2s;

      &:hover {
        filter: brightness(0.9);
      }
    }
  }
`;
